module.exports = __webpack_public_path__ + "static/media/3 12 Tulleord Knain er feil.ea5f9360.mp3";